// apps/web/src/api/arrival-cities.ts — typed wrappers around
// `/api/arrival-cities/*`. Same shared error-surface contract as the
// transport-types module.
import {
  ArrivalCitySchema,
  GetArrivalCitiesResponseSchema,
  type ArrivalCity,
  type CreateArrivalCityInput,
  type GetArrivalCitiesQuery,
  type GetArrivalCitiesResponse,
  type PatchArrivalCityInput,
} from '@magimp/shared';
import { request } from './client.js';

function withQuery(path: string, qs: string): string {
  return qs.length > 0 ? `${path}?${qs}` : path;
}

export function listArrivalCities(
  query: Partial<GetArrivalCitiesQuery> = {},
): Promise<GetArrivalCitiesResponse> {
  const params = new URLSearchParams();
  if (query.q) params.set('q', query.q);
  if (query.active !== undefined) params.set('active', String(query.active));
  if (query.cursor) params.set('cursor', query.cursor);
  if (query.limit !== undefined) params.set('limit', String(query.limit));
  return request<GetArrivalCitiesResponse>(
    withQuery('/arrival-cities', params.toString()),
    { method: 'GET' },
    {},
    GetArrivalCitiesResponseSchema,
  );
}

export function fetchArrivalCity(id: string): Promise<ArrivalCity> {
  return request<ArrivalCity>(
    `/arrival-cities/${encodeURIComponent(id)}`,
    { method: 'GET' },
    {},
    ArrivalCitySchema,
  );
}

export function createArrivalCity(body: CreateArrivalCityInput): Promise<ArrivalCity> {
  return request<ArrivalCity>(
    '/arrival-cities',
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    ArrivalCitySchema,
  );
}

export function patchArrivalCity(id: string, body: PatchArrivalCityInput): Promise<ArrivalCity> {
  return request<ArrivalCity>(
    `/arrival-cities/${encodeURIComponent(id)}`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    ArrivalCitySchema,
  );
}

export function archiveArrivalCity(id: string): Promise<ArrivalCity> {
  return request<ArrivalCity>(
    `/arrival-cities/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
    {},
    ArrivalCitySchema,
  );
}

export function activateArrivalCity(id: string): Promise<ArrivalCity> {
  return request<ArrivalCity>(
    `/arrival-cities/${encodeURIComponent(id)}/activate`,
    { method: 'POST' },
    {},
    ArrivalCitySchema,
  );
}
